import * as v from "valibot";
import {
  SourcingReviewBucket,
  SourcingReviewIssue,
} from "@/shared/gql/graphql";

export const searchParams = v.object({
  bucket: v.optional(v.enum(SourcingReviewBucket)),
  issue: v.optional(v.enum(SourcingReviewIssue)),
  page: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
});

export type SourcingReviewSearch = v.InferOutput<typeof searchParams>;
